// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"12203de8","361":"a014bd2e","511":"5e114fa8","673":"dcd88d08"}[chunkId] + ".chunk.js";
};